import { useUnit } from 'effector-react'

import {
  $kpiSettingsList,
  $totalCountOfKPISettings,
  getKPISettings,
  kpiSettingsListMounted,
  saveUserSetting,
  putUserSetting,
  submitUpdateManagersQuantity,
  updateManagersQuantity,
} from './model'
import { KPISettingsRequest } from './types'

export const useKPISettingList = () => {
  const kpiSettingList = useUnit($kpiSettingsList)
  const loading = useUnit(getKPISettings.pending)
  const saving = useUnit(putUserSetting.pending)
  const savingQty = useUnit(updateManagersQuantity.pending)
  const totalCountOfKPI = useUnit($totalCountOfKPISettings)

  const onChangeKPISettingsList = ({
    periodName,
    page,
    limit,
  }: KPISettingsRequest) => {
    kpiSettingsListMounted({ periodName, page, limit })
  }

  const onSaveUserSetting = (params: {
    id: number
    evaluation: number
    isIgnoreSpeedCounting: boolean
  }) => {
    saveUserSetting(params)
  }

  const onUpdateManagersQuantity = (params: {
    id: number
    managersQuantity: number
  }) => {
    submitUpdateManagersQuantity(params)
  }

  return {
    kpiSettingList,
    loading,
    saving,
    savingQty,
    onChangeKPISettingsList,
    onSaveUserSetting,
    onUpdateManagersQuantity,
    totalCountOfKPI,
  }
}
